import { API_URL } from "../constants/api";
import { getAxios, postAxios } from "../helpers";

class ReceiverService {

  getAll(params = null) {
    let url = API_URL.RECEIVER.GET_ALL;
    return getAxios(url, params);
  }

  getById(id) {
    const url = API_URL.RECEIVER.GET_BY_ID.replace(":id", id);
    return getAxios(url);
  }

  create(params) {
    const url = API_URL.RECEIVER.CREATE;
    return postAxios(url, params);
  }

  updateById(id, params) {
    const url = API_URL.RECEIVER.UPDATE_BY_ID.replace(":id", id);
    return postAxios(url, params, "put");
  }

  deleteById(id) {
    const url = API_URL.RECEIVER.DELETE_BY_ID.replace(":id", id);
    return postAxios(url, {}, "delete");
  }

}

export default new ReceiverService();
